/**
 * Maps backend destination strings to frontend URLs
 * Based on the backend UserSerializer.get_destination method
 *
 * Note: Only funnel workflow destinations (funnel_workflow_ssc,
 * funnel_workflow_ssc_unified) are affected by the redirect logic. Member destinations
 * use separate logic.
 */
export const DESTINATION_URL_MAPPING: Record<string, string> = {
    // Member destinations (NOT affected by funnel redirect logic)
    dashboard: '/dashboard',

    // Funnel workflow destinations (AFFECTED by funnel redirect logic)
    funnel_workflow_ssc: '/get-started', // SSC funnel
    funnel_workflow_ssc_unified: '/start', // Unified funnel (legacy key, still stored on old leads)
    ssc_unified: '/start', // Unified funnel (base orchestrator — FunnelVersion.SSC_UNIFIED)

    // Default destination
    personal_info: '/sign-up/personal-information',
};

/**
 * Funnel workflow destinations that are affected by the redirect logic
 */
export const FUNNEL_WORKFLOW_DESTINATIONS = [
    'funnel_workflow_ssc',
    'funnel_workflow_ssc_unified',
    'ssc_unified',
] as const;

export type FunnelWorkflowDestination = (typeof FUNNEL_WORKFLOW_DESTINATIONS)[number];

/**
 * Converts a backend destination string to a frontend URL
 * @param destination - The destination string from the backend
 * @returns The corresponding frontend URL, or the default personal_info URL if not found
 */
export function getDestinationUrl(destination?: string): string {
    if (!destination) {
        return DESTINATION_URL_MAPPING.personal_info;
    }

    const mappedUrl = DESTINATION_URL_MAPPING[destination] || DESTINATION_URL_MAPPING.personal_info;

    return mappedUrl;
}
